(function(){
  'use strict';

  function wrapBeforeColonInLi(li){
    if(!li || (li.querySelector('.enchliving-acento-label') || li.querySelector('.enchliving-decor-label'))) return;

    const walker = document.createTreeWalker(li, NodeFilter.SHOW_TEXT, {
      acceptNode(node){
        return (node.nodeValue && node.nodeValue.indexOf(':') !== -1) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });

    const found = walker.nextNode();
    if(!found) return;

    const idx = found.nodeValue.indexOf(':');
    if(idx === -1) return;

    try {
      const range = document.createRange();
      range.setStart(li, 0);
      range.setEnd(found, idx);
      const wrapper = document.createElement('span');
      wrapper.className = 'enchliving-faq-label';
      range.surroundContents(wrapper);

      let next = wrapper.nextSibling;
      if(next){
        if(next.nodeType === 3){
          next.nodeValue = next.nodeValue.replace(/^:\s?/, '');
        } else if(next.nodeType === 1 && next.firstChild && next.firstChild.nodeType === 3){
          next.firstChild.nodeValue = next.firstChild.nodeValue.replace(/^:\s?/, '');
        }
      }
    } catch (e) {
      li.innerHTML = li.innerHTML.replace(/([^:]*?):/, function(m, g1){
        return '<span class="enchliving-faq-label">' + g1 + '</span> ';
      });
    }
  }

  function process(){
    const items = document.querySelectorAll('.shopify-section--faq-override-enchliving .accordion__content .metafield-rich_text_field ul li');
    items.forEach(li => {
      if(li.closest && (li.closest('[data-brand="acento"]') || li.closest('[data-brand="decor-living"]'))) wrapBeforeColonInLi(li);
    });
  }

  document.addEventListener('DOMContentLoaded', process);

  const observer = new MutationObserver(function(mutations){
    let shouldRun = false;
    for(const m of mutations){
      for(const n of m.addedNodes){
        if(n.nodeType === 1 && (n.matches && (n.matches('.shopify-section--faq-override-enchliving') || n.closest && n.closest('.shopify-section--faq-override-enchliving')))){
          shouldRun = true;
          break;
        }
      }
      if(shouldRun) break;
    }
    if(shouldRun) process();
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
